import useGroups from '../contacts/use-groups';
import useFuseSearch from './use-fuse-search';

export default function useSearchGroup(keyword: string) {
  const { groups, isLoading } = useGroups();

  const keys = ['GroupName'];

  const filteredGroups = useFuseSearch({
    data: Object.values(groups),
    keys,
    keyword,
    mapResultItem: ({ item, matches, score }) => ({
      ...item,
      FuzzySearch: { highlightRanges: matches, score },
    }),
  });
  return { filteredGroups, isLoading };
}
